import React, { useEffect } from "react";
import "./Dashboard.css";
import Layout from "../../Components/Layout/Layout";
import InfoDashboard from "../../Components/InfoDashboard/InfoDashboard";
import CompetitiveIntelligence from "../../Components/CompetitiveIntelligence/CompetitiveIntelligence";

const Dashboard = () => {
  useEffect(() => {}, []);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  return (
    <Layout>
      <div
        className="child-section-of-everypage"
        style={{ paddingTop: "",marginBottom: "" }}
      >
        <InfoDashboard />
        <CompetitiveIntelligence />
      </div>
    </Layout>
  );
};
export default Dashboard;
